<template>
    <mainStarAssignmentComponent/>
</template>

<script>
import mainStarAssignmentComponent from "@/views/star_assignment/pages/star_assignment/components/main_star_assignment_component.vue"
export default {
    name: "starAssignment",
    components: {
        mainStarAssignmentComponent
    },
}
</script>

<style lang="css" scoped>
</style>